import React, { useRef, useState } from 'react';
import styles from './scss/importcsv.module.scss';
import { tableOptions } from '../../../components/custom_components/tableOptions';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import BlurToastDemo from '../../../components/custom_components/blurtast/blurtoast';
import { sendToNlpCSVFile } from '../../../apiservice/aiPilot';
import { useNavigate } from 'react-router-dom';

const ImportCsv = () => {
    const fileInputRef = useRef<HTMLInputElement | null>(null);
    const [toastOpen, setToastOpen] = useState(false);
    const [toastMessage, setToastMessage] = useState("");
    const navigate = useNavigate();

    // Allowed extensions
    const allowedExtensions = [".csv", ".xls", ".xlsx", ".zip", ".pdf"];
    const columns = [
        {
            dataField: "file_name",
            text: "File Name",
            sort: true,
            formatter: (item: string) => {
                return <span className='clickabletxt'>{item}</span>
            }
        },
        {
            dataField: "uploaded_on",
            text: "Uploaded On",
            sort: true,
        },
        {
            dataField: "status",
            text: "Status",
            formatter: (item: string) => {
                return <span className={`${styles.statuselem} ${styles.processed}`}>{item}</span>
            }
        },
        {
            dataField: "records",
            text: "Records",
            sort: true,
        },
    ];

    const data = [
        { file_name: 'customers_aug.csv', uploaded_on: 'Aug 8, 10:14 AM	', status: 'processed', records: '4,500' },
    ]

    const tableOpt = {
        ...tableOptions, sizePerPageList: [...tableOptions.sizePerPageList, {
            text: "All",
            value: 20,
        }]
    }

    const handleButtonClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click(); // open file picker
        }
    };

    const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file) return;

        const ext = "." + file.name.split(".").pop()?.toLowerCase();
        if (!allowedExtensions.includes(ext)) {
            alert("Invalid file type! Allowed: " + allowedExtensions.join(", "));
            return;
        }

        try {
            const formData = new FormData();
            formData.append("file", file);

            const res = await sendToNlpCSVFile(formData);
            console.log("Upload success:", res.data);

            const baseFileName = file.name.replace(/\.[^/.]+$/, "");
            if (baseFileName === "CDP_DATA") {
                setToastMessage("File uploaded successfully");
                setToastOpen(true);
                setTimeout(() => {
                    navigate("/aiPilotAnimation");
                }, 2000);
            } else {
                setToastMessage("Your file has been submitted for the CDP process.");
                setToastOpen(true);
                setTimeout(() => {
                    setToastOpen(false);
                }, 3000);
            }

            if (fileInputRef.current) {
                fileInputRef.current.value = "";
            }
        } catch (err) {
            console.error("Upload error:", err);
            alert("Upload failed, try again!");
        }
    };


    return (
        <div className={styles.importcsvsec}>

            <div className={styles.connectorblockheader}>
                <div className={styles.connectorblocktitle}>Upload your files</div>
                <div className={styles.connectorblockdesc}>Before uploading, ensure your file matches the required format and contains valid data.</div>
            </div>

            <div className={styles.optionsbtns}>
                <button className="primarybtn" onClick={handleButtonClick}>Upload</button>
                
                <input
                    type="file"
                    ref={fileInputRef}
                    style={{ display: "none" }}
                    onChange={handleFileChange}
                    accept={allowedExtensions.join(",")}
                />
                <div>
                    {/* Toast */}
                    <BlurToastDemo
                        open={toastOpen}
                        onClose={() => {
                            setToastOpen(false);
                            // navigate("/aiPilot"); 
                        }} message={(close) => (
                            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                ✅ {toastMessage}
                                <svg
                                    style={{ cursor: "pointer" }}
                                    onClick={close}   // 🔹 closes instantly
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="11"
                                    height="10"
                                    viewBox="0 0 11 10"
                                    fill="none"
                                >
                                    <path
                                        d="M6.29984 4.99937L10.2032 1.09571C10.4245 0.874973 10.4245 0.51564 10.2032 0.294906C9.98184 0.0735729 9.62244 0.0735729 9.40237 0.294906L5.49904 4.19851L1.59571 0.294906C1.37564 0.0735729 1.01497 0.0735729 0.794906 0.294906C0.573573 0.51564 0.573573 0.874973 0.794906 1.09571L4.69824 4.99937L0.794906 8.90304C0.573573 9.12377 0.573573 9.48311 0.794906 9.70384C0.905573 9.81451 1.05011 9.86984 1.19531 9.86984C1.34051 9.86984 1.48564 9.81451 1.59571 9.70384L5.49904 5.80024L9.40237 9.70384C9.51237 9.81451 9.65757 9.86984 9.80277 9.86984C9.94797 9.86984 10.0925 9.81451 10.2032 9.70384C10.4245 9.48311 10.4245 9.12377 10.2032 8.90304L6.29984 4.99937Z"
                                        fill="white"
                                    />
                                </svg>
                            </div>
                        )}
                    />
                </div>

                {/* <button className='cancelbtn'>Download Template</button> */}
            </div>
            {/* <div className={styles.topheading}>
                <div className={styles.tophdlefts}>
                    <h2>Recent Uploads</h2>
                    <p className={styles.headerdesctxt}>View the latest files you’ve imported, along with their upload date, status, and record count.</p>
                </div>
                <div className={styles.tophdrights}>
                    <button className='cancelbtn'>Import History</button>
                </div>
            </div> */}
            {/* <BlurToastDemo
        trigger={<button style={{ padding: "8px 16px", borderRadius: "8px" }}>Click Me</button>}
      /> */}
            {/* <div className='desktoptable'>
                <BootstrapTable
                    keyField="id"
                    data={data}
                    columns={columns}
                    pagination={paginationFactory(tableOpt)}
                // noDataIndication={<NoTableData />}
                />
            </div> */}
        </div>
    )
}

export default ImportCsv
